export default Object.freeze({
    VERIFY: 0,
    ACCESS: 1,
    BLOCK: 2,
});